export default __webpack_public_path__ + "static/media/icInstagram.5baafb31.svg";